/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable @next/next/no-img-element */
import { FC } from 'react';

import { TColorProp } from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

import { CheckOptionContainer } from './styles';
import { IFormLabelProps } from '../Form/FormLabel/types';
import { FormLabel } from '../Form/FormLabel';
import { Checkbox } from '../Form/Checkbox';

interface IGenericCheckOptionProps {
  label?: IFormLabelProps;
  selected?: boolean;
  disabled?: boolean;
  background?: TColorProp;
  hoverColor?: TColorProp;
  selectedBorderColor?: TColorProp;
  image?: string;
  onSelect?: () => void;
}
export const GenericCheckOption: FC<IGenericCheckOptionProps> = ({
  label,
  selected,
  disabled = false,
  hoverColor = 'neutral.900',
  image,
  background = 'neutral.950',
  selectedBorderColor = 'green.500',
  onSelect,
}) => {
  return (
    <CheckOptionContainer
      onClick={onSelect}
      selected={selected}
      disabled={disabled}
      background={background}
      hoverColor={hoverColor}
      selectedBorderColor={selectedBorderColor}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: SPACING._8,
        }}
      >
        {image && (
          <img
            src={image}
            alt="image"
            style={{ width: '30px', height: '30px' }}
          />
        )}

        <FormLabel {...label} />
      </div>

      <Checkbox isChecked={selected} onToggle={onSelect} />
    </CheckOptionContainer>
  );
};
